import { PropCategory } from "building-types/props/propCategoryTypes";
import { PropId } from "building-types/props/propIds";
import type { PropAttributes } from "building-types/props/propTypes";
import { PropBoundOrientation } from "building-types/props/propTypesEnum";
import type { InteriorPropSettings } from "building-types/settings/interiorPropSettings";
import { propCatalogItemNew } from "doc/propTools";

export enum BuiltInInteriorPropId {
  REFRIGERATOR = "refrigerator",
  REFRIGERATORSIDE = "refrigeratorSide",
  REFRIGERATORBOTTOM = "refrigeratorBottom",
  REFRIGERATORTOP = "refrigeratorTop",
  FRIDGEUNDERCOUNTER = "fridgeUnderCounter",
  FRIDGEWINE24 = "fridgeWine24",
  DISHWASHER = "dishwasher",
  OVEN = "oven",
  OVENGAS = "ovenGas",
  RANGE20 = "range20",
  RANGETOP = "rangetop",
  RANGETOPGAS = "rangetopGas",
  OVENWALLDOUBLE = "ovenWallDouble",
  OVENWALLDOUBLEGAS = "ovenWallDoubleGas",
  OVENWALL = "ovenWall",
  OVENWALLGAS = "ovenWallGas",
  MICROWAVE = "microwave",
  TOILET = "toilet",
  TOILETWASHLET = "toiletWashlet",
  SINKPEDESTAL = "sinkPedestal",
  SINKDOUBLE = "sinkDouble",
  SINKDOUBLE36 = "sinkDouble36",
  SINKSINGLE = "sinkSingle",
  SINKUTILITY = "sinkUtility",
  SINKSINGLEAPRON = "sinkSingleApron",
  SINKVANITY = "sinkVanity",
  STOOLBACK = "stoolBack",
  BATHTUB = "bathtub",
  BATHTUB6030 = "bathtub6030",
  BATHTUB6030CLAW = "bathtub6030Claw",
  BATHTUB6042 = "bathtub6042",
  BATHTUB7245 = "bathtub7245",
  BATHTUB7242 = "bathtub7242",
  BATHTUBBASIN6042 = "bathtubBasin6042",
  BATHTUBCLAW = "bathtubClaw",
  FAUCET = "faucet",
  FAUCETSTANDING = "faucetStanding",
  FAUCETWALL = "faucetWall",
  SHOWER = "shower",
  SHOWERVALVE = "showerValve",
  TOWELBAR = "towelBar",
  TOWELHOOK = "towelHook",
  TOWELHAND = "towelHand",
  TPHOLDER = "tpHolder",
  BATHCOMBO = "bathCombo",
  BEDQUEEN = "bedQueen",
  BEDKING = "bedKing",
  DRESSERHIGH = "dresserHigh",
  DRESSERLOW = "dresserLow",
  ENDTABLE = "endtable",
  DININGSET = "diningSet",
  DININGROUND = "diningRound",
  DININGSMALL = "diningSmall",
  DININGCHAIR = "diningChair",
  TABLE6 = "table6",
  COUCH = "couch",
  LOVESEAT = "loveseat",
  ARMCHAIR = "armchair",
  TVCABINET = "tvCabinet",
  HUTCH = "hutch",
  COFFEETABLE = "coffeeTable",
  TV = "tv",
  FIREPLACEICONWOOD = "fireplaceIconWood",
  SIMPLIFIRE38 = "simplifire38",
  SIMPLIFIRE58 = "simplifire58",
  DESKSET = "deskSet",
  BOOKSHELF5 = "bookshelf5",
  BOOKSHELF6 = "bookshelf6",
  CHAIROFFICE = "chairOffice",
  DRYER = "dryer",
  WASHER = "washer",
  FURNACE = "furnace",
  DOORINTERIORLOW = "doorInteriorLow",
  DOORINTERIOR = "doorInterior",
  DOORINTERIOR1668 = "doorInterior1668",
  DOORINTERIOR2068 = "doorInterior2068",
  DOORINTERIOR2468 = "doorInterior2468",
  DOORINTERIOR2668 = "doorInterior2668",
  DOORINTERIOR2868 = "doorInterior2868",
  DOORINTERIOR3068 = "doorInterior3068",
  DOORINTERIOR3268 = "doorInterior3268",
  DOORINTERIOR1680 = "doorInterior1680",
  DOORINTERIOR2080 = "doorInterior2080",
  DOORINTERIOR2480 = "doorInterior2480",
  DOORINTERIOR2680 = "doorInterior2680",
  DOORINTERIOR2880 = "doorInterior2880",
  DOORINTERIOR3080 = "doorInterior3080",
  DOORINTERIOR3280 = "doorInterior3280",
  DOORINTERIORBARN3068 = "doorInteriorBarn3068",
  DOORINTERIORBARN3080 = "doorInteriorBarn3080",
  DOORINTERIORBARNDOUBLE3068 = "doorInteriorBarnDouble3068",
  DOORINTERIORBARNDOUBLE3080 = "doorInteriorBarnDouble3080",
  DOORINTERIORBIFOLD4068 = "doorInteriorBiFold4068",
  DOORINTERIORBIFOLD4080 = "doorInteriorBiFold4080",
  DOORINTERIORCLOSET1668 = "doorInteriorCloset1668",
  DOORINTERIORCLOSET1868 = "doorInteriorCloset1868",
  DOORINTERIORCLOSET2068 = "doorInteriorCloset2068",
  DOORINTERIORCLOSET2468 = "doorInteriorCloset2468",
  DOORINTERIORCLOSET2668 = "doorInteriorCloset2668",
  DOORINTERIORCLOSET2868 = "doorInteriorCloset2868",
  DOORINTERIORCLOSET3068 = "doorInteriorCloset3068",
  DOORINTERIORCLOSET3268 = "doorInteriorCloset3268",
  DOORINTERIORCLOSET1680 = "doorInteriorCloset1680",
  DOORINTERIORCLOSET1880 = "doorInteriorCloset1880",
  DOORINTERIORCLOSET2080 = "doorInteriorCloset2080",
  DOORINTERIORCLOSET2480 = "doorInteriorCloset2480",
  DOORINTERIORCLOSET2680 = "doorInteriorCloset2680",
  DOORINTERIORCLOSET2880 = "doorInteriorCloset2880",
  DOORINTERIORCLOSET3080 = "doorInteriorCloset3080",
  DOORINTERIORCLOSET3280 = "doorInteriorCloset3280",
  DOORINTERIORLOUVRED2868 = "doorInteriorLouvred2868",
  DOORINTERIORLOUVRED2880 = "doorInteriorLouvred2880",
  DOORINTERIORPOCKET1668 = "doorInteriorPocket1668",
  DOORINTERIORPOCKET2068 = "doorInteriorPocket2068",
  DOORINTERIORPOCKET2468 = "doorInteriorPocket2468",
  DOORINTERIORPOCKET2668 = "doorInteriorPocket2668",
  DOORINTERIORPOCKET2868 = "doorInteriorPocket2868",
  DOORINTERIORPOCKET3068 = "doorInteriorPocket3068",
  DOORINTERIORPOCKET3268 = "doorInteriorPocket3268",
  DOORINTERIORPOCKET1680 = "doorInteriorPocket1680",
  DOORINTERIORPOCKET2080 = "doorInteriorPocket2080",
  DOORINTERIORPOCKET2480 = "doorInteriorPocket2480",
  DOORINTERIORPOCKET2680 = "doorInteriorPocket2680",
  DOORINTERIORPOCKET2880 = "doorInteriorPocket2880",
  DOORINTERIORPOCKET3080 = "doorInteriorPocket3080",
  DOORINTERIORPOCKET3280 = "doorInteriorPocket3280",
  DOORINTERIORDOUBLE3068 = "doorInteriorDouble3068",
  DOORINTERIORDOUBLE4068 = "doorInteriorDouble4068",
  DOORINTERIORDOUBLE4868 = "doorInteriorDouble4868",
  DOORINTERIORDOUBLE5068 = "doorInteriorDouble5068",
  DOORINTERIORDOUBLE5468 = "doorInteriorDouble5468",
  DOORINTERIORDOUBLE6068 = "doorInteriorDouble6068",
  DOORINTERIORDOUBLE6468 = "doorInteriorDouble6468",
  DOORINTERIORDOUBLE3080 = "doorInteriorDouble3080",
  DOORINTERIORDOUBLE4080 = "doorInteriorDouble4080",
  DOORINTERIORDOUBLE4880 = "doorInteriorDouble4880",
  DOORINTERIORDOUBLE5080 = "doorInteriorDouble5080",
  DOORINTERIORDOUBLE5480 = "doorInteriorDouble5480",
  DOORINTERIORDOUBLE6080 = "doorInteriorDouble6080",
  DOORINTERIORDOUBLE6480 = "doorInteriorDouble6480",
  DOORINTERIORDOUBLECLOSET3068 = "doorInteriorDoubleCloset3068",
  DOORINTERIORDOUBLECLOSET4068 = "doorInteriorDoubleCloset4068",
  DOORINTERIORDOUBLECLOSET4868 = "doorInteriorDoubleCloset4868",
  DOORINTERIORDOUBLECLOSET5068 = "doorInteriorDoubleCloset5068",
  DOORINTERIORDOUBLECLOSET5468 = "doorInteriorDoubleCloset5468",
  DOORINTERIORDOUBLECLOSET6068 = "doorInteriorDoubleCloset6068",
  DOORINTERIORDOUBLECLOSET6468 = "doorInteriorDoubleCloset6468",
  DOORINTERIORDOUBLECLOSET3080 = "doorInteriorDoubleCloset3080",
  DOORINTERIORDOUBLECLOSET4080 = "doorInteriorDoubleCloset4080",
  DOORINTERIORDOUBLECLOSET4880 = "doorInteriorDoubleCloset4880",
  DOORINTERIORDOUBLECLOSET5080 = "doorInteriorDoubleCloset5080",
  DOORINTERIORDOUBLECLOSET5480 = "doorInteriorDoubleCloset5480",
  DOORINTERIORDOUBLECLOSET6080 = "doorInteriorDoubleCloset6080",
  DOORINTERIORDOUBLECLOSET6480 = "doorInteriorDoubleCloset6480",
  DOORDOUBLEFRENCH5068 = "doorDoubleFrench5068",
  DOORDOUBLEFRENCH5080 = "doorDoubleFrench5080",
  DOORDOUBLEFRENCH15LITE5068 = "doorDoubleFrench15Lite5068",
  DOORDOUBLEFRENCH15LITE5080 = "doorDoubleFrench15Lite5080",
  DOORDOUBLEFRENCHTRANSOM6068 = "doorDoubleFrenchTransom6068",
  DOORINTERIORDOUBLEBYPASS3068 = "doorInteriorDoubleBypass3068",
  DOORINTERIORDOUBLEBYPASS4068 = "doorInteriorDoubleBypass4068",
  DOORINTERIORDOUBLEBYPASS4868 = "doorInteriorDoubleBypass4868",
  DOORINTERIORDOUBLEBYPASS5068 = "doorInteriorDoubleBypass5068",
  DOORINTERIORDOUBLEBYPASS5468 = "doorInteriorDoubleBypass5468",
  DOORINTERIORDOUBLEBYPASS6068 = "doorInteriorDoubleBypass6068",
  DOORINTERIORDOUBLEBYPASS6468 = "doorInteriorDoubleBypass6468",
  DOORINTERIORDOUBLEBYPASS3080 = "doorInteriorDoubleBypass3080",
  DOORINTERIORDOUBLEBYPASS4080 = "doorInteriorDoubleBypass4080",
  DOORINTERIORDOUBLEBYPASS4880 = "doorInteriorDoubleBypass4880",
  DOORINTERIORDOUBLEBYPASS5080 = "doorInteriorDoubleBypass5080",
  DOORINTERIORDOUBLEBYPASS5480 = "doorInteriorDoubleBypass5480",
  DOORINTERIORDOUBLEBYPASS6080 = "doorInteriorDoubleBypass6080",
  DOORINTERIORDOUBLEBYPASS6480 = "doorInteriorDoubleBypass6480",
  DOORSINGLEOVERHEAD = "doorSingleOverhead",
  BEDTWIN = "bedTwin",
  BEDFULL = "bedFull",
  SEDANINTERIOR = "sedanInterior",
  SUVINTERIOR = "suvInterior",
  TRUCKINTERIOR = "truckInterior",
  WATERHEATER = "waterHeater",
  WATERHEATERGAS = "waterHeaterGas",
  ACUNIT = "acUnit",
  EXTERIORLAMPINTERIOR = "exteriorLampInterior",
  EXTERIORLAMPGASINTERIOR = "exteriorLampGasInterior",
  EXTERIORLAMP2 = "exteriorLamp2",
  HOSEBIB = "hoseBib",
  CRAFTSHUTTERINTERIOR = "craftShutterInterior",
  CRAFTCOLUMNINTERIOR = "craftColumnInterior",
  TANKLESSWATERHEATER = "tanklessWaterHeater",
  TANKLESSWATERHEATERGAS = "tanklessWaterHeaterGas",
  FIREPLACE = "fireplace",
  FIREPLACEINSERT = "fireplaceInsert",
  AWNINGBRACKETINTERIOR = "awningBracketInterior",
  ANGLEBRACKET14X18INTERIOR = "angleBracket14x18Interior",
  ANGLEBRACKET25X27INTERIOR = "angleBracket25x27Interior",
  ANGLEBRACKET20X20INTERIOR = "angleBracket20x20Interior",
  SOFFITCORBEL8X12INTERIOR = "soffitCorbel8x12Interior",
  ELLIOTTGABLEARCH12INTERIOR = "elliottGableArch12Interior",
  ELLIOTTGABLEARCH7INTERIOR = "elliottGableArch7Interior",
  ELLIOTTGABLEARCH8INTERIOR = "elliottGableArch8Interior",
  ELLIOTTGABLEARCH9INTERIOR = "elliottGableArch9Interior",
  SHUTTERS3050INTERIOR = "shutters3050Interior",
  SHOWERPAN60X42 = "showerPan60x42",
  SHOWERPAN36X36 = "showerPan36x36",
  SHOWERPAN42X42 = "showerPan42x42",
  SHOWERPAN60X36 = "showerPan60x36",
  RAKEBRACKETINTERIOR = "rakeBracketInterior",
  STAIRSPULLDOWN = "stairsPullDown",
  SHOWERINSERTFULLSEAT60X36 = "showerInsertFullSeat60x36",
  TUBINSERTSHOWER60X42 = "tubInsertShower60x42",
  MIRROR = "mirror",
}

export const defaultInteriorPropCatalog: { [key in BuiltInInteriorPropId]: PropAttributes } = {
  mirror: propCatalogItemNew({
    id: BuiltInInteriorPropId.MIRROR,
    name: "mirror",
    propAssetId: PropId.Bath_Mirror_Framed_Wall_32x24_01,
    takeoffDescription: "bathroom mirror",
    category: PropCategory.FIXTURES,
  }),
  refrigerator: propCatalogItemNew({
    id: BuiltInInteriorPropId.REFRIGERATOR,
    name: "refrigerator",
    propAssetId: PropId.Kitchen_Fridge35_French_01,
    floorPlanTag: "REF",
    isPlumbingArchitecturalProp: true,
    takeoffDescription: "refrigerator",
    category: PropCategory.APPLIANCES,
  }),
  refrigeratorSide: propCatalogItemNew({
    id: BuiltInInteriorPropId.REFRIGERATORSIDE,
    name: "refrigeratorSide",
    propAssetId: PropId.Kitchen_Fridge35_Side_01,
    isPlumbingArchitecturalProp: true,
    category: PropCategory.APPLIANCES,
  }),
  refrigeratorBottom: propCatalogItemNew({
    id: BuiltInInteriorPropId.REFRIGERATORBOTTOM,
    name: "refrigeratorBottom",
    propAssetId: PropId.Kitchen_Fridge29_Bottom_01,
    isPlumbingArchitecturalProp: true,
    category: PropCategory.APPLIANCES,
  }),
  refrigeratorTop: propCatalogItemNew({
    id: BuiltInInteriorPropId.REFRIGERATORTOP,
    name: "refrigeratorTop",
    propAssetId: PropId.Kitchen_Fridge29_Top_01,
    floorPlanTag: "REF",
    isPlumbingArchitecturalProp: true,
    category: PropCategory.APPLIANCES,
  }),
  fridgeUnderCounter: propCatalogItemNew({
    id: BuiltInInteriorPropId.FRIDGEUNDERCOUNTER,
    name: "fridgeUnderCounter",
    propAssetId: PropId.Kitchen_FridgeMini24_Single_01,
    isPlumbingArchitecturalProp: true,
    category: PropCategory.APPLIANCES,
  }),
  fridgeWine24: propCatalogItemNew({
    id: BuiltInInteriorPropId.FRIDGEWINE24,
    name: "fridgeWine24",
    propAssetId: PropId.Kitchen_FridgeMini24_Wine_01,
    isPlumbingArchitecturalProp: true,
    category: PropCategory.APPLIANCES,
  }),
  dishwasher: propCatalogItemNew({
    id: BuiltInInteriorPropId.DISHWASHER,
    name: "dishwasher",
    propAssetId: PropId.Kitchen_Dishwasher24_01,
    floorPlanTag: "DW",
    isPlumbingArchitecturalProp: true,
    excludeFromFoundationPlanDimensions: true,
    takeoffDescription: "dishwasher",
    category: PropCategory.APPLIANCES,
  }),
  oven: propCatalogItemNew({
    id: BuiltInInteriorPropId.OVEN,
    name: "oven",
    propAssetId: PropId.Kitchen_Oven30_Range_G01,
    isElectricalArchitecturalProp: true,
    takeoffDescription: "oven",
    category: PropCategory.APPLIANCES,
  }),
  ovenGas: propCatalogItemNew({
    id: BuiltInInteriorPropId.OVENGAS,
    name: "ovenGas",
    propAssetId: PropId.Kitchen_Oven30_Range_G01,
    floorPlanTag: "GAS",
    isElectricalArchitecturalProp: true,
    category: PropCategory.APPLIANCES,
  }),
  range20: propCatalogItemNew({
    id: BuiltInInteriorPropId.RANGE20,
    name: "range20",
    propAssetId: PropId.Kitchen_Oven20_Range_E01,
    category: PropCategory.APPLIANCES,
  }),
  rangetop: propCatalogItemNew({
    id: BuiltInInteriorPropId.RANGETOP,
    name: "rangetop",
    propAssetId: PropId.Kitchen_Cooktop30_G01,
    takeoffDescription: "rangetop",
    category: PropCategory.APPLIANCES,
  }),
  rangetopGas: propCatalogItemNew({
    id: BuiltInInteriorPropId.RANGETOPGAS,
    name: "rangetopGas",
    propAssetId: PropId.Kitchen_Cooktop30_G01,
    floorPlanTag: "GAS",
    category: PropCategory.APPLIANCES,
  }),
  ovenWallDouble: propCatalogItemNew({
    id: BuiltInInteriorPropId.OVENWALLDOUBLE,
    name: "ovenWallDouble",
    propAssetId: PropId.Kitchen_Oven30Oven_Wall_01,
    isElectricalArchitecturalProp: true,
    takeoffDescription: "oven wall double",
    category: PropCategory.APPLIANCES,
  }),
  ovenWallDoubleGas: propCatalogItemNew({
    id: BuiltInInteriorPropId.OVENWALLDOUBLEGAS,
    name: "ovenWallDoubleGas",
    propAssetId: PropId.Kitchen_Oven30Oven_Wall_01,
    floorPlanTag: "GAS \n DBL OVEN",
    isElectricalArchitecturalProp: true,
    category: PropCategory.APPLIANCES,
  }),
  ovenWall: propCatalogItemNew({
    id: BuiltInInteriorPropId.OVENWALL,
    name: "ovenWall",
    propAssetId: PropId.Kitchen_Oven30_Wall_01,
    isElectricalArchitecturalProp: true,
    category: PropCategory.APPLIANCES,
  }),
  ovenWallGas: propCatalogItemNew({
    id: BuiltInInteriorPropId.OVENWALLGAS,
    name: "ovenWallGas",
    propAssetId: PropId.Kitchen_Oven30_Wall_01,
    floorPlanTag: "GAS \n OVEN",
    isElectricalArchitecturalProp: true,
    category: PropCategory.APPLIANCES,
  }),
  microwave: propCatalogItemNew({
    id: BuiltInInteriorPropId.MICROWAVE,
    name: "microwave",
    propAssetId: PropId.Kitchen_Microwave30_Wall_01,
    floorPlanTag: "MIC",
    takeoffDescription: "microwave",
    category: PropCategory.APPLIANCES,
  }),
  toilet: propCatalogItemNew({
    id: BuiltInInteriorPropId.TOILET,
    name: "toilet",
    propAssetId: PropId.Bath_Toilet_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    takeoffDescription: "toilet",
    category: PropCategory.FIXTURES,
  }),
  toiletWashlet: propCatalogItemNew({
    id: BuiltInInteriorPropId.TOILETWASHLET,
    name: "toiletWashlet",
    propAssetId: PropId.Bath_Toilet_Washlet_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    takeoffDescription: "toilet washlet",
    category: PropCategory.FIXTURES,
  }),
  sinkPedestal: propCatalogItemNew({
    id: BuiltInInteriorPropId.SINKPEDESTAL,
    name: "sinkPedestal",
    propAssetId: PropId.Bath_Sink_Pedestal_23x18x34h_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    takeoffDescription: "sink pedestal",
    category: PropCategory.FIXTURES,
  }),
  sinkDouble: propCatalogItemNew({
    id: BuiltInInteriorPropId.SINKDOUBLE,
    name: "sinkDouble",
    propAssetId: PropId.Kitchen_Sink42_Double_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    defaultVerticalOffset: 36,
    takeoffDescription: "sink double",
    category: PropCategory.FIXTURES,
  }),
  sinkDouble36: propCatalogItemNew({
    id: BuiltInInteriorPropId.SINKDOUBLE36,
    name: "sinkDouble36",
    propAssetId: PropId.Kitchen_Sink36_Double_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    defaultVerticalOffset: 36,
    takeoffDescription: "sink double",
    category: PropCategory.FIXTURES,
  }),
  sinkSingle: propCatalogItemNew({
    id: BuiltInInteriorPropId.SINKSINGLE,
    name: "sinkSingle",
    propAssetId: PropId.Kitchen_Sink30_Single_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    defaultVerticalOffset: 36,
    takeoffDescription: "sink single",
    category: PropCategory.FIXTURES,
  }),
  sinkUtility: propCatalogItemNew({
    id: BuiltInInteriorPropId.SINKUTILITY,
    name: "sinkUtility",
    propAssetId: PropId.Laundry_Sink_Utility_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    takeoffDescription: "sink utility",
    category: PropCategory.FIXTURES,
  }),
  sinkSingleApron: propCatalogItemNew({
    id: BuiltInInteriorPropId.SINKSINGLEAPRON,
    name: "sinkSingleApron",
    propAssetId: PropId.Kitchen_Sink36_SingleApron_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    defaultVerticalOffset: 36,
    takeoffDescription: "sink single apron",
    category: PropCategory.FIXTURES,
  }),
  sinkVanity: propCatalogItemNew({
    id: BuiltInInteriorPropId.SINKVANITY,
    name: "sinkVanity",
    propAssetId: PropId.Bath_Sink_Above_23x18_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    defaultVerticalOffset: 36,
    takeoffDescription: "sink vanity",
    category: PropCategory.FIXTURES,
  }),
  stoolBack: propCatalogItemNew({
    id: BuiltInInteriorPropId.STOOLBACK,
    name: "stoolBack",
    propAssetId: PropId.Dining_Seat_DiningTall_01,
    category: PropCategory.FURNITURE,
  }),
  bathtub: propCatalogItemNew({
    id: BuiltInInteriorPropId.BATHTUB,
    name: "bathtub",
    propAssetId: PropId.Bath_Tub_Freestand_60x30_01,
    floorPlanTag: '36"X60"',
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    takeoffDescription: "bathtub",
    category: PropCategory.FIXTURES,
  }),
  bathtub6030: propCatalogItemNew({
    id: BuiltInInteriorPropId.BATHTUB6030,
    name: "bathtub6030",
    propAssetId: PropId.Bath_Tub_FreestandBasin_60x30_01,
    category: PropCategory.FIXTURES,
  }),
  bathtub6030Claw: propCatalogItemNew({
    id: BuiltInInteriorPropId.BATHTUB6030CLAW,
    name: "bathtub6030Claw",
    propAssetId: PropId.Bath_Tub_FreestandClawBasin_60x30_01,
    category: PropCategory.FIXTURES,
  }),
  bathtub6042: propCatalogItemNew({
    id: BuiltInInteriorPropId.BATHTUB6042,
    name: "bathtub6042",
    propAssetId: PropId.Bath_Tub_InsertBasin_60x42_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    propBoundOrientation: PropBoundOrientation.LONG_PROP,
    category: PropCategory.FIXTURES,
  }),
  bathtub7245: propCatalogItemNew({
    id: BuiltInInteriorPropId.BATHTUB7245,
    name: "bathtub7245",
    propAssetId: PropId.Bath_Tub_InsertSoaking_72x45_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    propBoundOrientation: PropBoundOrientation.LONG_PROP,
    category: PropCategory.FIXTURES,
  }),
  bathtub7242: propCatalogItemNew({
    id: BuiltInInteriorPropId.BATHTUB7242,
    name: "bathtub7242",
    propAssetId: PropId.Bath_Tub_InsertBasin_72x42_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    propBoundOrientation: PropBoundOrientation.LONG_PROP,
    category: PropCategory.FIXTURES,
  }),
  bathtubBasin6042: propCatalogItemNew({
    id: BuiltInInteriorPropId.BATHTUBBASIN6042,
    name: "bathtubBasin6042",
    propAssetId: PropId.Bath_Tub_InsertBasin_60x32_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    propBoundOrientation: PropBoundOrientation.LONG_PROP,
    category: PropCategory.FIXTURES,
  }),
  bathtubClaw: propCatalogItemNew({
    id: BuiltInInteriorPropId.BATHTUBCLAW,
    name: "bathtubClaw",
    propAssetId: PropId.Bath_Tub_FreestandClaw_60x30_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    takeoffDescription: "bathtub claw",
    category: PropCategory.FIXTURES,
  }),
  faucet: propCatalogItemNew({
    id: BuiltInInteriorPropId.FAUCET,
    name: "faucet",
    propAssetId: PropId.Bath_Tub_Faucet_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    category: PropCategory.FIXTURES,
  }),
  faucetStanding: propCatalogItemNew({
    id: BuiltInInteriorPropId.FAUCETSTANDING,
    name: "faucetStanding",
    propAssetId: PropId.Bath_Tub_FaucetFreestand_01,
    category: PropCategory.FIXTURES,
  }),
  faucetWall: propCatalogItemNew({
    id: BuiltInInteriorPropId.FAUCETWALL,
    name: "faucetWall",
    propAssetId: PropId.Bath_Tub_FaucetWall_01,
    category: PropCategory.FIXTURES,
  }),
  shower: propCatalogItemNew({
    id: BuiltInInteriorPropId.SHOWER,
    name: "shower",
    propAssetId: PropId.Bath_Shower_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    takeoffDescription: "shower",
    propBoundOrientation: PropBoundOrientation.CENTER_PROP,
    category: PropCategory.FIXTURES,
  }),
  showerValve: propCatalogItemNew({
    id: BuiltInInteriorPropId.SHOWERVALVE,
    name: "showerValve",
    propAssetId: PropId.Bath_Shower_Valve_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    propBoundOrientation: PropBoundOrientation.CENTER_PROP,
    category: PropCategory.FIXTURES,
  }),
  towelBar: propCatalogItemNew({
    id: BuiltInInteriorPropId.TOWELBAR,
    name: "towelBar",
    propAssetId: PropId.Bath_Towel_Bar24_01,
    floorPlanTag: "TB",
    hideTagOnElectricalPlan: true,
    defaultVerticalOffset: 36,
    category: PropCategory.FIXTURES,
  }),
  towelHook: propCatalogItemNew({
    id: BuiltInInteriorPropId.TOWELHOOK,
    name: "towelHook",
    propAssetId: PropId.Bath_Towel_Hook2_01,
    floorPlanTag: "TH",
    hideTagOnElectricalPlan: true,
    defaultVerticalOffset: 56,
    category: PropCategory.FIXTURES,
  }),
  towelHand: propCatalogItemNew({
    id: BuiltInInteriorPropId.TOWELHAND,
    name: "towelHand",
    propAssetId: PropId.Bath_Towel_Hand_01,
    floorPlanTag: "TR",
    hideTagOnElectricalPlan: true,
    defaultVerticalOffset: 40,
    category: PropCategory.FIXTURES,
  }),
  tpHolder: propCatalogItemNew({
    id: BuiltInInteriorPropId.TPHOLDER,
    name: "tpHolder",
    propAssetId: PropId.Bath_TP_01,
    floorPlanTag: "PH",
    hideTagOnElectricalPlan: true,
    category: PropCategory.FIXTURES,
  }),
  bathCombo: propCatalogItemNew({
    id: BuiltInInteriorPropId.BATHCOMBO,
    name: "bathCombo",
    propAssetId: PropId.Bath_Combo_Insert_60x30_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    takeoffDescription: "bath combo",
    propBoundOrientation: PropBoundOrientation.LONG_PROP,
    category: PropCategory.FIXTURES,
  }),
  bedQueen: propCatalogItemNew({
    id: BuiltInInteriorPropId.BEDQUEEN,
    name: "bedQueen",
    propAssetId: PropId.Bed_Bed_Queen_01,
    category: PropCategory.FURNITURE,
  }),
  bedKing: propCatalogItemNew({
    id: BuiltInInteriorPropId.BEDKING,
    name: "bedKing",
    propAssetId: PropId.Bed_Bed_King_01,
    category: PropCategory.FURNITURE,
  }),
  dresserHigh: propCatalogItemNew({
    id: BuiltInInteriorPropId.DRESSERHIGH,
    name: "dresserHigh",
    propAssetId: PropId.Bed_Dresser_Chest_01,
    category: PropCategory.FURNITURE,
  }),
  dresserLow: propCatalogItemNew({
    id: BuiltInInteriorPropId.DRESSERLOW,
    name: "dresserLow",
    propAssetId: PropId.Bed_Dresser_01,
    category: PropCategory.FURNITURE,
  }),
  endtable: propCatalogItemNew({
    id: BuiltInInteriorPropId.ENDTABLE,
    name: "endtable",
    propAssetId: PropId.Bed_Dresser_Nightstand_01,
    category: PropCategory.FURNITURE,
  }),
  diningSet: propCatalogItemNew({
    id: BuiltInInteriorPropId.DININGSET,
    name: "diningSet",
    propAssetId: PropId.Dining_Dine_8LongBench_01,
    category: PropCategory.FURNITURE,
  }),
  diningRound: propCatalogItemNew({
    id: BuiltInInteriorPropId.DININGROUND,
    name: "diningRound",
    propAssetId: PropId.Dining_Dine_6Round_01,
    category: PropCategory.FURNITURE,
  }),
  diningSmall: propCatalogItemNew({
    id: BuiltInInteriorPropId.DININGSMALL,
    name: "diningSmall",
    propAssetId: PropId.Dining_Dine_4Round_01,
    category: PropCategory.FURNITURE,
  }),
  diningChair: propCatalogItemNew({
    id: BuiltInInteriorPropId.DININGCHAIR,
    name: "diningChair",
    propAssetId: PropId.Dining_Seat_Dining_01,
    category: PropCategory.FURNITURE,
  }),
  table6: propCatalogItemNew({
    id: BuiltInInteriorPropId.TABLE6,
    name: "table6",
    propAssetId: PropId.Dining_Table_6Long_01,
    category: PropCategory.FURNITURE,
  }),
  couch: propCatalogItemNew({
    id: BuiltInInteriorPropId.COUCH,
    name: "couch",
    propAssetId: PropId.Living_Seat_Sofa3Straight_01,
    category: PropCategory.FURNITURE,
  }),
  loveseat: propCatalogItemNew({
    id: BuiltInInteriorPropId.LOVESEAT,
    name: "loveseat",
    propAssetId: PropId.Living_Seat_LoveSeat_01,
    category: PropCategory.FURNITURE,
  }),
  armchair: propCatalogItemNew({
    id: BuiltInInteriorPropId.ARMCHAIR,
    name: "armchair",
    propAssetId: PropId.Living_Seat_ArmChair_01,
    category: PropCategory.FURNITURE,
  }),
  tvCabinet: propCatalogItemNew({
    id: BuiltInInteriorPropId.TVCABINET,
    name: "tvCabinet",
    propAssetId: PropId.Living_Cabinet_TV_01,
    category: PropCategory.FURNITURE,
  }),
  hutch: propCatalogItemNew({
    id: BuiltInInteriorPropId.HUTCH,
    name: "hutch",
    propAssetId: PropId.Dining_Cabinet_Hutch_01,
    category: PropCategory.FURNITURE,
  }),
  coffeeTable: propCatalogItemNew({
    id: BuiltInInteriorPropId.COFFEETABLE,
    name: "coffeeTable",
    propAssetId: PropId.Living_Table_Coffee_01,
    category: PropCategory.FURNITURE,
  }),
  tv: propCatalogItemNew({
    id: BuiltInInteriorPropId.TV,
    name: "tv",
    propAssetId: PropId.Living_TV_65Wall_01,
    category: PropCategory.FURNITURE,
    floorPlanTag: "TV",
  }),
  fireplaceIconWood: propCatalogItemNew({
    id: BuiltInInteriorPropId.FIREPLACEICONWOOD,
    name: "fireplaceIconWood",
    propAssetId: PropId.General_Fireplace_IconI60_01,
    category: PropCategory.FIXTURES,
  }),
  simplifire38: propCatalogItemNew({
    id: BuiltInInteriorPropId.SIMPLIFIRE38,
    name: "simplifire38",
    propAssetId: PropId.General_Fireplace_Simplifire38_01,
    floorPlanTag: "S38",
    category: PropCategory.FIXTURES,
  }),
  simplifire58: propCatalogItemNew({
    id: BuiltInInteriorPropId.SIMPLIFIRE58,
    name: "simplifire58",
    propAssetId: PropId.General_Fireplace_Simplifire58_01,
    floorPlanTag: "S58",
    category: PropCategory.FIXTURES,
  }),
  deskSet: propCatalogItemNew({
    id: BuiltInInteriorPropId.DESKSET,
    name: "deskSet",
    propAssetId: PropId.Office_DeskSet_2Cabinet_01,
    category: PropCategory.FURNITURE,
  }),
  bookshelf5: propCatalogItemNew({
    id: BuiltInInteriorPropId.BOOKSHELF5,
    name: "bookshelf5",
    propAssetId: PropId.Office_Bookcase_5Single_01,
    category: PropCategory.FURNITURE,
    takeoffDescription: "bookshelf 5",
  }),
  bookshelf6: propCatalogItemNew({
    id: BuiltInInteriorPropId.BOOKSHELF6,
    name: "bookshelf6",
    propAssetId: PropId.Office_Bookcase_6Single_01,
    category: PropCategory.FURNITURE,
    takeoffDescription: "bookshelf 6",
  }),
  chairOffice: propCatalogItemNew({
    id: BuiltInInteriorPropId.CHAIROFFICE,
    name: "chairOffice",
    propAssetId: PropId.Office_Chair_Roll_01,
    category: PropCategory.FURNITURE,
  }),
  dryer: propCatalogItemNew({
    id: BuiltInInteriorPropId.DRYER,
    name: "dryer",
    propAssetId: PropId.Laundry_Dryer_Front_01,
    floorPlanTag: "D",
    isPlumbingArchitecturalProp: true,
    takeoffDescription: "dryer",
  }),
  washer: propCatalogItemNew({
    id: BuiltInInteriorPropId.WASHER,
    name: "washer",
    propAssetId: PropId.Laundry_Washer_Top_01,
    floorPlanTag: "W",
    isPlumbingArchitecturalProp: true,
    takeoffDescription: "washer",
  }),
  furnace: propCatalogItemNew({
    id: BuiltInInteriorPropId.FURNACE,
    name: "furnace",
    propAssetId: PropId.Utility_Heater_GMSS960603BN_01,
    category: PropCategory.FIXTURES,
  }),
  doorInteriorLow: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORLOW,
    name: "doorInteriorLow",
    propAssetId: PropId.DoorInt_Single30_01,
  }),
  doorInterior: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIOR,
    name: "doorInterior",
    propAssetId: PropId.DoorInt_Single30_02,
  }),
  doorInterior1668: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIOR1668,
    name: "doorInterior1668",
    propAssetId: PropId.DoorInt_Single18_01,
  }),
  doorInterior2068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIOR2068,
    name: "doorInterior2068",
    propAssetId: PropId.DoorInt_Single24_01,
  }),
  doorInterior2468: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIOR2468,
    name: "doorInterior2468",
    propAssetId: PropId.DoorInt_Single28_01,
  }),
  doorInterior2668: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIOR2668,
    name: "doorInterior2668",
    propAssetId: PropId.DoorInt_Single30_01,
  }),
  doorInterior2868: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIOR2868,
    name: "doorInterior2868",
    propAssetId: PropId.DoorInt_Single32_01,
  }),
  doorInterior3068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIOR3068,
    name: "doorInterior3068",
    propAssetId: PropId.DoorInt_Single36_01,
  }),
  doorInterior3268: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIOR3268,
    name: "doorInterior3268",
    propAssetId: PropId.DoorInt_Single38_01,
  }),
  doorInterior1680: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIOR1680,
    name: "doorInterior1680",
    propAssetId: PropId.DoorInt_Single18_02,
  }),
  doorInterior2080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIOR2080,
    name: "doorInterior2080",
    propAssetId: PropId.DoorInt_Single24_02,
  }),
  doorInterior2480: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIOR2480,
    name: "doorInterior2480",
    propAssetId: PropId.DoorInt_Single28_02,
  }),
  doorInterior2680: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIOR2680,
    name: "doorInterior2680",
    propAssetId: PropId.DoorInt_Single30_02,
  }),
  doorInterior2880: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIOR2880,
    name: "doorInterior2880",
    propAssetId: PropId.DoorInt_Single32_02,
  }),
  doorInterior3080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIOR3080,
    name: "doorInterior3080",
    propAssetId: PropId.DoorInt_Single36_02,
  }),
  doorInterior3280: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIOR3280,
    name: "doorInterior3280",
    propAssetId: PropId.DoorInt_Single38_02,
  }),
  doorInteriorBarn3068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORBARN3068,
    name: "doorInteriorBarn3068",
    propAssetId: PropId.DoorInt_Single36_Barn_01,
  }),
  doorInteriorBarn3080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORBARN3080,
    name: "doorInteriorBarn3080",
    propAssetId: PropId.DoorInt_Single36_Barn_02,
  }),
  doorInteriorBarnDouble3068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORBARNDOUBLE3068,
    name: "doorInteriorBarnDouble3068",
    propAssetId: PropId.DoorInt_Double36_Barn_01,
  }),
  doorInteriorBarnDouble3080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORBARNDOUBLE3080,
    name: "doorInteriorBarnDouble3080",
    propAssetId: PropId.DoorInt_Double36_Barn_02,
  }),
  doorInteriorBiFold4068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORBIFOLD4068,
    name: "doorInteriorBiFold4068",
    propAssetId: PropId.DoorInt_Single48_BiFold_01,
  }),
  doorInteriorBiFold4080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORBIFOLD4080,
    name: "doorInteriorBiFold4080",
    propAssetId: PropId.DoorInt_Single48_BiFold_02,
  }),
  doorInteriorCloset1668: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORCLOSET1668,
    name: "doorInteriorCloset1668",
    propAssetId: PropId.DoorInt_Single18_Closet_01,
  }),
  doorInteriorCloset1868: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORCLOSET1868,
    name: "doorInteriorCloset1868",
    propAssetId: PropId.DoorInt_Single20_Closet_01,
  }),
  doorInteriorCloset2068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORCLOSET2068,
    name: "doorInteriorCloset2068",
    propAssetId: PropId.DoorInt_Single24_Closet_01,
  }),
  doorInteriorCloset2468: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORCLOSET2468,
    name: "doorInteriorCloset2468",
    propAssetId: PropId.DoorInt_Single28_Closet_01,
  }),
  doorInteriorCloset2668: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORCLOSET2668,
    name: "doorInteriorCloset2668",
    propAssetId: PropId.DoorInt_Single30_Closet_01,
  }),
  doorInteriorCloset2868: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORCLOSET2868,
    name: "doorInteriorCloset2868",
    propAssetId: PropId.DoorInt_Single32_Closet_01,
  }),
  doorInteriorCloset3068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORCLOSET3068,
    name: "doorInteriorCloset3068",
    propAssetId: PropId.DoorInt_Single36_Closet_01,
  }),
  doorInteriorCloset3268: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORCLOSET3268,
    name: "doorInteriorCloset3268",
    propAssetId: PropId.DoorInt_Single38_Closet_01,
  }),
  doorInteriorCloset1680: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORCLOSET1680,
    name: "doorInteriorCloset1680",
    propAssetId: PropId.DoorInt_Single18_Closet_02,
  }),
  doorInteriorCloset1880: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORCLOSET1880,
    name: "doorInteriorCloset1880",
    propAssetId: PropId.DoorInt_Single20_Closet_02,
  }),
  doorInteriorCloset2080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORCLOSET2080,
    name: "doorInteriorCloset2080",
    propAssetId: PropId.DoorInt_Single24_Closet_02,
  }),
  doorInteriorCloset2480: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORCLOSET2480,
    name: "doorInteriorCloset2480",
    propAssetId: PropId.DoorInt_Single28_Closet_02,
  }),
  doorInteriorCloset2680: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORCLOSET2680,
    name: "doorInteriorCloset2680",
    propAssetId: PropId.DoorInt_Single30_Closet_02,
  }),
  doorInteriorCloset2880: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORCLOSET2880,
    name: "doorInteriorCloset2880",
    propAssetId: PropId.DoorInt_Single32_Closet_02,
  }),
  doorInteriorCloset3080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORCLOSET3080,
    name: "doorInteriorCloset3080",
    propAssetId: PropId.DoorInt_Single36_Closet_02,
  }),
  doorInteriorCloset3280: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORCLOSET3280,
    name: "doorInteriorCloset3280",
    propAssetId: PropId.DoorInt_Single38_Closet_02,
  }),
  doorInteriorLouvred2868: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORLOUVRED2868,
    name: "doorInteriorLouvred2868",
    propAssetId: PropId.DoorInt_Single32_Louvred_01,
  }),
  doorInteriorLouvred2880: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORLOUVRED2880,
    name: "doorInteriorLouvred2880",
    propAssetId: PropId.DoorInt_Single32_Louvred_02,
  }),
  doorInteriorPocket1668: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORPOCKET1668,
    name: "doorInteriorPocket1668",
    propAssetId: PropId.DoorInt_Single18_Pocket_01,
  }),
  doorInteriorPocket2068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORPOCKET2068,
    name: "doorInteriorPocket2068",
    propAssetId: PropId.DoorInt_Single24_Pocket_01,
  }),
  doorInteriorPocket2468: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORPOCKET2468,
    name: "doorInteriorPocket2468",
    propAssetId: PropId.DoorInt_Single28_Pocket_01,
  }),
  doorInteriorPocket2668: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORPOCKET2668,
    name: "doorInteriorPocket2668",
    propAssetId: PropId.DoorInt_Single30_Pocket_01,
  }),
  doorInteriorPocket2868: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORPOCKET2868,
    name: "doorInteriorPocket2868",
    propAssetId: PropId.DoorInt_Single32_Pocket_01,
  }),
  doorInteriorPocket3068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORPOCKET3068,
    name: "doorInteriorPocket3068",
    propAssetId: PropId.DoorInt_Single36_Pocket_01,
  }),
  doorInteriorPocket3268: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORPOCKET3268,
    name: "doorInteriorPocket3268",
    propAssetId: PropId.DoorInt_Single38_Pocket_01,
  }),
  doorInteriorPocket1680: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORPOCKET1680,
    name: "doorInteriorPocket1680",
    propAssetId: PropId.DoorInt_Single18_Pocket_02,
  }),
  doorInteriorPocket2080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORPOCKET2080,
    name: "doorInteriorPocket2080",
    propAssetId: PropId.DoorInt_Single24_Pocket_02,
  }),
  doorInteriorPocket2480: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORPOCKET2480,
    name: "doorInteriorPocket2480",
    propAssetId: PropId.DoorInt_Single28_Pocket_02,
  }),
  doorInteriorPocket2680: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORPOCKET2680,
    name: "doorInteriorPocket2680",
    propAssetId: PropId.DoorInt_Single30_Pocket_02,
  }),
  doorInteriorPocket2880: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORPOCKET2880,
    name: "doorInteriorPocket2880",
    propAssetId: PropId.DoorInt_Single32_Pocket_02,
  }),
  doorInteriorPocket3080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORPOCKET3080,
    name: "doorInteriorPocket3080",
    propAssetId: PropId.DoorInt_Single36_Pocket_02,
  }),
  doorInteriorPocket3280: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORPOCKET3280,
    name: "doorInteriorPocket3280",
    propAssetId: PropId.DoorInt_Single38_Pocket_02,
  }),
  doorInteriorDouble3068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLE3068,
    name: "doorInteriorDouble3068",
    propAssetId: PropId.DoorInt_Double18_01,
  }),
  doorInteriorDouble4068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLE4068,
    name: "doorInteriorDouble4068",
    propAssetId: PropId.DoorInt_Double24_01,
  }),
  doorInteriorDouble4868: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLE4868,
    name: "doorInteriorDouble4868",
    propAssetId: PropId.DoorInt_Double28_01,
  }),
  doorInteriorDouble5068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLE5068,
    name: "doorInteriorDouble5068",
    propAssetId: PropId.DoorInt_Double30_01,
  }),
  doorInteriorDouble5468: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLE5468,
    name: "doorInteriorDouble5468",
    propAssetId: PropId.DoorInt_Double32_01,
  }),
  doorInteriorDouble6068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLE6068,
    name: "doorInteriorDouble6068",
    propAssetId: PropId.DoorInt_Double36_01,
  }),
  doorInteriorDouble6468: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLE6468,
    name: "doorInteriorDouble6468",
    propAssetId: PropId.DoorInt_Double38_01,
  }),
  doorInteriorDouble3080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLE3080,
    name: "doorInteriorDouble3080",
    propAssetId: PropId.DoorInt_Double18_02,
  }),
  doorInteriorDouble4080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLE4080,
    name: "doorInteriorDouble4080",
    propAssetId: PropId.DoorInt_Double24_02,
  }),
  doorInteriorDouble4880: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLE4880,
    name: "doorInteriorDouble4880",
    propAssetId: PropId.DoorInt_Double28_02,
  }),
  doorInteriorDouble5080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLE5080,
    name: "doorInteriorDouble5080",
    propAssetId: PropId.DoorInt_Double30_02,
  }),
  doorInteriorDouble5480: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLE5480,
    name: "doorInteriorDouble5480",
    propAssetId: PropId.DoorInt_Double32_02,
  }),
  doorInteriorDouble6080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLE6080,
    name: "doorInteriorDouble6080",
    propAssetId: PropId.DoorInt_Double36_02,
  }),
  doorInteriorDouble6480: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLE6480,
    name: "doorInteriorDouble6480",
    propAssetId: PropId.DoorInt_Double38_02,
  }),
  doorInteriorDoubleCloset3068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLECLOSET3068,
    name: "doorInteriorDoubleCloset3068",
    propAssetId: PropId.DoorInt_Double18_Closet_01,
  }),
  doorInteriorDoubleCloset4068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLECLOSET4068,
    name: "doorInteriorDoubleCloset4068",
    propAssetId: PropId.DoorInt_Double24_Closet_01,
  }),
  doorInteriorDoubleCloset4868: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLECLOSET4868,
    name: "doorInteriorDoubleCloset4868",
    propAssetId: PropId.DoorInt_Double28_Closet_01,
  }),
  doorInteriorDoubleCloset5068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLECLOSET5068,
    name: "doorInteriorDoubleCloset5068",
    propAssetId: PropId.DoorInt_Double30_Closet_01,
  }),
  doorInteriorDoubleCloset5468: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLECLOSET5468,
    name: "doorInteriorDoubleCloset5468",
    propAssetId: PropId.DoorInt_Double32_Closet_01,
  }),
  doorInteriorDoubleCloset6068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLECLOSET6068,
    name: "doorInteriorDoubleCloset6068",
    propAssetId: PropId.DoorInt_Double36_Closet_01,
  }),
  doorInteriorDoubleCloset6468: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLECLOSET6468,
    name: "doorInteriorDoubleCloset6468",
    propAssetId: PropId.DoorInt_Double38_Closet_01,
  }),
  doorInteriorDoubleCloset3080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLECLOSET3080,
    name: "doorInteriorDoubleCloset3080",
    propAssetId: PropId.DoorInt_Double18_Closet_02,
  }),
  doorInteriorDoubleCloset4080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLECLOSET4080,
    name: "doorInteriorDoubleCloset4080",
    propAssetId: PropId.DoorInt_Double24_Closet_02,
  }),
  doorInteriorDoubleCloset4880: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLECLOSET4880,
    name: "doorInteriorDoubleCloset4880",
    propAssetId: PropId.DoorInt_Double28_Closet_02,
  }),
  doorInteriorDoubleCloset5080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLECLOSET5080,
    name: "doorInteriorDoubleCloset5080",
    propAssetId: PropId.DoorInt_Double30_Closet_02,
  }),
  doorInteriorDoubleCloset5480: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLECLOSET5480,
    name: "doorInteriorDoubleCloset5480",
    propAssetId: PropId.DoorInt_Double32_Closet_02,
  }),
  doorInteriorDoubleCloset6080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLECLOSET6080,
    name: "doorInteriorDoubleCloset6080",
    propAssetId: PropId.DoorInt_Double36_Closet_02,
  }),
  doorInteriorDoubleCloset6480: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLECLOSET6480,
    name: "doorInteriorDoubleCloset6480",
    propAssetId: PropId.DoorInt_Double38_Closet_02,
  }),
  doorDoubleFrench5068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORDOUBLEFRENCH5068,
    name: "doorDoubleFrench5068",
    propAssetId: PropId.DoorInt_Double30_French_01,
  }),
  doorDoubleFrench5080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORDOUBLEFRENCH5080,
    name: "doorDoubleFrench5080",
    propAssetId: PropId.DoorInt_Double30_French_02,
  }),
  doorDoubleFrench15Lite5068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORDOUBLEFRENCH15LITE5068,
    name: "doorDoubleFrench15Lite5068",
    propAssetId: PropId.DoorInt_Double30_French_01,
  }),
  doorDoubleFrench15Lite5080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORDOUBLEFRENCH15LITE5080,
    name: "doorDoubleFrench15Lite5080",
    propAssetId: PropId.DoorInt_Double30_French_02,
  }),
  doorDoubleFrenchTransom6068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORDOUBLEFRENCHTRANSOM6068,
    name: "doorDoubleFrenchTransom6068",
    propAssetId: PropId.DoorInt_Double36_French_Transom_01,
  }),
  doorInteriorDoubleBypass3068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLEBYPASS3068,
    name: "doorInteriorDoubleBypass3068",
    propAssetId: PropId.DoorInt_Double18_Bypass_01,
  }),
  doorInteriorDoubleBypass4068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLEBYPASS4068,
    name: "doorInteriorDoubleBypass4068",
    propAssetId: PropId.DoorInt_Double24_Bypass_01,
  }),
  doorInteriorDoubleBypass4868: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLEBYPASS4868,
    name: "doorInteriorDoubleBypass4868",
    propAssetId: PropId.DoorInt_Double28_Bypass_01,
  }),
  doorInteriorDoubleBypass5068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLEBYPASS5068,
    name: "doorInteriorDoubleBypass5068",
    propAssetId: PropId.DoorInt_Double30_Bypass_01,
  }),
  doorInteriorDoubleBypass5468: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLEBYPASS5468,
    name: "doorInteriorDoubleBypass5468",
    propAssetId: PropId.DoorInt_Double32_Bypass_01,
  }),
  doorInteriorDoubleBypass6068: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLEBYPASS6068,
    name: "doorInteriorDoubleBypass6068",
    propAssetId: PropId.DoorInt_Double36_Bypass_01,
  }),
  doorInteriorDoubleBypass6468: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLEBYPASS6468,
    name: "doorInteriorDoubleBypass6468",
    propAssetId: PropId.DoorInt_Double38_Bypass_01,
  }),
  doorInteriorDoubleBypass3080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLEBYPASS3080,
    name: "doorInteriorDoubleBypass3080",
    propAssetId: PropId.DoorInt_Double18_Bypass_02,
  }),
  doorInteriorDoubleBypass4080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLEBYPASS4080,
    name: "doorInteriorDoubleBypass4080",
    propAssetId: PropId.DoorInt_Double24_Bypass_02,
  }),
  doorInteriorDoubleBypass4880: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLEBYPASS4880,
    name: "doorInteriorDoubleBypass4880",
    propAssetId: PropId.DoorInt_Double28_Bypass_02,
  }),
  doorInteriorDoubleBypass5080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLEBYPASS5080,
    name: "doorInteriorDoubleBypass5080",
    propAssetId: PropId.DoorInt_Double30_Bypass_02,
  }),
  doorInteriorDoubleBypass5480: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLEBYPASS5480,
    name: "doorInteriorDoubleBypass5480",
    propAssetId: PropId.DoorInt_Double32_Bypass_02,
  }),
  doorInteriorDoubleBypass6080: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLEBYPASS6080,
    name: "doorInteriorDoubleBypass6080",
    propAssetId: PropId.DoorInt_Double36_Bypass_02,
  }),
  doorInteriorDoubleBypass6480: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORINTERIORDOUBLEBYPASS6480,
    name: "doorInteriorDoubleBypass6480",
    propAssetId: PropId.DoorInt_Double38_Bypass_02,
  }),
  doorSingleOverhead: propCatalogItemNew({
    id: BuiltInInteriorPropId.DOORSINGLEOVERHEAD,
    name: "doorSingleOverhead",
    propAssetId: PropId.DoorExt_Overhang108_2x4Glass_01,
  }),
  bedTwin: propCatalogItemNew({
    id: BuiltInInteriorPropId.BEDTWIN,
    name: "bedTwin",
    propAssetId: PropId.Bed_Bed_Twin_01,
    category: PropCategory.FURNITURE,
  }),
  bedFull: propCatalogItemNew({
    id: BuiltInInteriorPropId.BEDFULL,
    name: "bedFull",
    propAssetId: PropId.Bed_Bed_Full_01,
    category: PropCategory.FURNITURE,
  }),
  sedanInterior: propCatalogItemNew({
    id: BuiltInInteriorPropId.SEDANINTERIOR,
    name: "sedan",
    propAssetId: PropId.Garage_Car_Sedan_01,
    category: PropCategory.FURNITURE,
  }),
  suvInterior: propCatalogItemNew({
    id: BuiltInInteriorPropId.SUVINTERIOR,
    name: "suv",
    propAssetId: PropId.Garage_SUV_Crossover_01,
    category: PropCategory.FURNITURE,
  }),
  truckInterior: propCatalogItemNew({
    id: BuiltInInteriorPropId.TRUCKINTERIOR,
    name: "truck",
    propAssetId: PropId.Garage_Truck_Pickup_01,
    category: PropCategory.FURNITURE,
  }),
  waterHeater: propCatalogItemNew({
    id: BuiltInInteriorPropId.WATERHEATER,
    name: "waterHeater",
    propAssetId: PropId.Utility_WaterHeater_50gTall_01,
    floorPlanTag: "WH",
    category: PropCategory.FIXTURES,
  }),
  waterHeaterGas: propCatalogItemNew({
    id: BuiltInInteriorPropId.WATERHEATERGAS,
    name: "waterHeaterGas",
    propAssetId: PropId.Utility_WaterHeater_50gTall_01,
    floorPlanTag: "GAS \n WH",
    category: PropCategory.FIXTURES,
  }),
  acUnit: propCatalogItemNew({
    id: BuiltInInteriorPropId.ACUNIT,
    name: "acUnit",
    propAssetId: PropId.Utility_AC_2halfTon_01,
    floorPlanTag: "AC",
    category: PropCategory.FIXTURES,
  }),
  exteriorLampInterior: propCatalogItemNew({
    id: BuiltInInteriorPropId.EXTERIORLAMPINTERIOR,
    name: "exteriorLampInterior",
    propAssetId: PropId.Lights_ExteriorWall_LanternFixed_01,
    useExteriorPalette: true,
    showOnElevationsAndPerspectives: true,
    category: PropCategory.FIXTURES,
  }),
  exteriorLampGasInterior: propCatalogItemNew({
    id: BuiltInInteriorPropId.EXTERIORLAMPGASINTERIOR,
    name: "exteriorLampGasInterior",
    propAssetId: PropId.Lights_ExteriorWall_LanternFixed_01,
    floorPlanTag: "GAS",
    useExteriorPalette: true,
    showOnElevationsAndPerspectives: true,
    category: PropCategory.FIXTURES,
  }),
  exteriorLamp2: propCatalogItemNew({
    id: BuiltInInteriorPropId.EXTERIORLAMP2,
    name: "exteriorLamp2",
    propAssetId: PropId.Lights_ExteriorWall_LanternShort_01,
    category: PropCategory.FIXTURES,
  }),
  hoseBib: propCatalogItemNew({
    id: BuiltInInteriorPropId.HOSEBIB,
    name: "hoseBib",
    propAssetId: PropId.Utility_Spigot_01,
    floorPlanTag: "HB",
    isUtilityArchitecturalProp: true,
    defaultVerticalOffset: 24,
    floorPlanTagOffsetX: -9,
    category: PropCategory.FIXTURES,
  }),
  craftShutterInterior: propCatalogItemNew({
    id: BuiltInInteriorPropId.CRAFTSHUTTERINTERIOR,
    name: "craftShutterInterior",
    propAssetId: PropId.Arch_ShutterShade_01,
    showOnElevationsAndPerspectives: true,
  }),
  craftColumnInterior: propCatalogItemNew({
    id: BuiltInInteriorPropId.CRAFTCOLUMNINTERIOR,
    name: "craftColumnInterior",
    propAssetId: PropId.Arch_Column120_Modern_01,
    useExteriorPalette: true,
    showOnElevationsAndPerspectives: true,
  }),
  tanklessWaterHeater: propCatalogItemNew({
    id: BuiltInInteriorPropId.TANKLESSWATERHEATER,
    name: "tanklessWaterHeater",
    propAssetId: PropId.Utility_WaterHeaterTankless_RTGK160N1_01,
    category: PropCategory.FIXTURES,
  }),
  tanklessWaterHeaterGas: propCatalogItemNew({
    id: BuiltInInteriorPropId.TANKLESSWATERHEATERGAS,
    name: "tanklessWaterHeaterGas",
    propAssetId: PropId.Utility_WaterHeaterTankless_RTGK160N1_01,
    floorPlanTag: "GAS \n TWH",
    category: PropCategory.FIXTURES,
  }),
  fireplace: propCatalogItemNew({
    id: BuiltInInteriorPropId.FIREPLACE,
    name: "fireplace",
    propAssetId: PropId.General_Fireplace_FullFrameMantle_01,
    takeoffDescription: "fireplace",
    category: PropCategory.FIXTURES,
  }),
  fireplaceInsert: propCatalogItemNew({
    id: BuiltInInteriorPropId.FIREPLACEINSERT,
    name: "fireplaceInsert",
    propAssetId: PropId.General_Fireplace_InsertModern_01,
    takeoffDescription: "fireplace insert",
    category: PropCategory.FIXTURES,
  }),
  awningBracketInterior: propCatalogItemNew({
    id: BuiltInInteriorPropId.AWNINGBRACKETINTERIOR,
    name: "awningBracketInterior",
    propAssetId: PropId.Arch_BracketFypon_BKT25x27_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  angleBracket14x18Interior: propCatalogItemNew({
    id: BuiltInInteriorPropId.ANGLEBRACKET14X18INTERIOR,
    name: "angleBracket14x18Interior",
    propAssetId: PropId.Arch_BracketAngledPost_14x18_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  angleBracket25x27Interior: propCatalogItemNew({
    id: BuiltInInteriorPropId.ANGLEBRACKET25X27INTERIOR,
    name: "angleBracket25x27Interior",
    propAssetId: PropId.Arch_BracketFypon_BKT25x27_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  angleBracket20x20Interior: propCatalogItemNew({
    id: BuiltInInteriorPropId.ANGLEBRACKET20X20INTERIOR,
    name: "angleBracket20x20Interior",
    propAssetId: PropId.Arch_BracketFypon_BKT20x20_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  soffitCorbel8x12Interior: propCatalogItemNew({
    id: BuiltInInteriorPropId.SOFFITCORBEL8X12INTERIOR,
    name: "soffitCorbel8x12Interior",
    propAssetId: PropId.Arch_SoffitCorbel_08x12_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  elliottGableArch12Interior: propCatalogItemNew({
    id: BuiltInInteriorPropId.ELLIOTTGABLEARCH12INTERIOR,
    name: "elliottGableArch12Interior",
    propAssetId: PropId.Arch_GableDetailArc_p12o12_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  elliottGableArch7Interior: propCatalogItemNew({
    id: BuiltInInteriorPropId.ELLIOTTGABLEARCH7INTERIOR,
    name: "elliottGableArch7Interior",
    propAssetId: PropId.Arch_GableDetailArc_p07o12_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  elliottGableArch8Interior: propCatalogItemNew({
    id: BuiltInInteriorPropId.ELLIOTTGABLEARCH8INTERIOR,
    name: "elliottGableArch8Interior",
    propAssetId: PropId.Arch_GableDetailArc_p08o12_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  elliottGableArch9Interior: propCatalogItemNew({
    id: BuiltInInteriorPropId.ELLIOTTGABLEARCH9INTERIOR,
    name: "elliottGableArch9Interior",
    propAssetId: PropId.Arch_GableDetailArc_p09o12_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  shutters3050Interior: propCatalogItemNew({
    id: BuiltInInteriorPropId.SHUTTERS3050INTERIOR,
    name: "shutters3050Interior",
    propAssetId: PropId.Arch_Layne_FakeShutter36x60_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  showerPan60x42: propCatalogItemNew({
    id: BuiltInInteriorPropId.SHOWERPAN60X42,
    name: "showerPan60x42",
    propAssetId: PropId.Bath_Shower_Insert_60x42_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    propBoundOrientation: PropBoundOrientation.CENTROID_PROP,
    category: PropCategory.FIXTURES,
  }),
  showerPan36x36: propCatalogItemNew({
    id: BuiltInInteriorPropId.SHOWERPAN36X36,
    name: "showerPan36x36",
    propAssetId: PropId.Bath_Shower_Insert_36x36_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    propBoundOrientation: PropBoundOrientation.CENTROID_PROP,
    category: PropCategory.FIXTURES,
  }),
  showerPan42x42: propCatalogItemNew({
    id: BuiltInInteriorPropId.SHOWERPAN42X42,
    name: "showerPan42x42",
    propAssetId: PropId.Bath_Shower_Insert_42x42_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    propBoundOrientation: PropBoundOrientation.CENTROID_PROP,
    category: PropCategory.FIXTURES,
  }),
  showerPan60x36: propCatalogItemNew({
    id: BuiltInInteriorPropId.SHOWERPAN60X36,
    name: "showerPan60x36",
    propAssetId: PropId.Bath_Shower_InsertFull_60x36_01,
    showOnElevationsAndPerspectives: true,
    isPlumbingArchitecturalProp: true,
    propBoundOrientation: PropBoundOrientation.CENTROID_PROP,
    category: PropCategory.FIXTURES,
  }),
  rakeBracketInterior: propCatalogItemNew({
    id: BuiltInInteriorPropId.RAKEBRACKETINTERIOR,
    name: "rakeBracketInterior",
    propAssetId: PropId.Arch_BracketLegacy_16_01,
    showOnElevationsAndPerspectives: true,
    useExteriorPalette: true,
  }),
  stairsPullDown: propCatalogItemNew({
    id: BuiltInInteriorPropId.STAIRSPULLDOWN,
    name: "stairsPullDown",
    propAssetId: PropId.Utility_AtticLadder_22Hx54_01,
    category: PropCategory.FIXTURES,
  }),
  showerInsertFullSeat60x36: propCatalogItemNew({
    id: BuiltInInteriorPropId.SHOWERINSERTFULLSEAT60X36,
    name: "showerInsertFullSeat60x36",
    propAssetId: PropId.Bath_Shower_InsertFullSeat_60x36_01,
    category: PropCategory.FIXTURES,
  }),
  tubInsertShower60x42: propCatalogItemNew({
    id: BuiltInInteriorPropId.TUBINSERTSHOWER60X42,
    name: "tubInsertShower60x42",
    propAssetId: PropId.Bath_Tub_InsertShower_60x42_01,
    category: PropCategory.FIXTURES,
  }),
};

export function getInteriorPropCatalog(interiorPropSettings: InteriorPropSettings) {
  // if we don't have prop settings, show the built-ins, otherwise show catalog items only
  const interiorPropCatalog = interiorPropSettings?.propTypes ?? {};

  if (interiorPropSettings?.displayBuiltInCatalog) {
    return interiorPropCatalog;
  } else {
    const builtInIds = new Set(Object.values(BuiltInInteriorPropId));
    const filteredCatalog = Object.keys(interiorPropCatalog).reduce(
      (acc, key) => {
        if (!builtInIds.has(key as BuiltInInteriorPropId)) {
          acc[key] = interiorPropCatalog[key];
        }
        return acc;
      },
      {} as { [key: string]: PropAttributes },
    );
    return Object.keys(filteredCatalog).length > 0 ? filteredCatalog : defaultInteriorPropCatalog;
  }
}
